<template>
    <v-card>
        <v-card-title>
            {{  $t('agent_settings')  }} -- {{ webinar.title}}
        </v-card-title>
        <v-card-text>
            <v-form ref="agentSettingsForm">
                <v-row>
                    <v-col cols="12">
                        <v-text-field v-model="agentSettingsEditedItem.api_token" label="api_token" class="left-input mt-3" ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="agentSettingsEditedItem.bbb_server_id" label="bbb_server_id" class="left-input mt-3"> </v-text-field>
                    </v-col> 
                    <v-col cols="12">
                        <v-text-field v-model="agentSettingsEditedItem.destination_id" label="destination_id" class="left-input mt-3"> </v-text-field>
                    </v-col>
                   
                </v-row>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text color="green darken-2" @click="saveAgentSettings">
                {{  $t('save')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="red darken-2" @click="removeAskDialog=true">
                {{  $t('remove')  }}
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="close">
                {{  $t('close')  }}
            </v-btn>
        </v-card-actions>
        <v-dialog v-model="removeAskDialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <v-icon large right color="red"> mdi-comment-question-outline</v-icon>
                </v-card-title>
                <v-card-text>
                    {{ $t('webinar_agent_settings_remove_ask')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="removeAgentSettings">{{ $t('yes') }}</v-btn>
                    <v-btn color="primary" text @click="removeAskDialog=false">{{ $t('no') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import axios from 'axios'
export default {
    name: 'AgentSettings',
    props: ['webinar'],
    data() {
        return {
            agentSettingsEditedItem: { api_token: "", bbb_server_id: "", destination_id: ""},
            agentSettingsDefaultItem: { api_token: "", bbb_server_id: "", destination_id: ""},
            saveLoading: false,
            deleteLoading: false,
            removeAskDialog:false,
        }
    },
    watch:{
        webinar:{
            handler(){
                this.getAgentSettings();
            },
            deep:true
        }
    },
    methods: {

        getAgentSettings() {
            axios({
                url: `${process.env.VUE_APP_BACKEND_URL}/api/webinar_plus/companies/${this.webinar.id}/agent_settings`,
                method: "GET",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(response => {
                this.agentSettingsEditedItem = Object.assign({}, response.data.data);
               // this.agentSettingsEditedItem.bigbluebutton_record=(response?.data?.data?.bigbluebutton_record==1?true:false)
            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("no_agent_settings"));
            });
        },
        saveAgentSettings() {
            console.log(this.agentSettingsEditedItem)
            let payload={...this.agentSettingsEditedItem};
            axios({
                url: `${process.env.VUE_APP_BACKEND_URL}/api/webinar_plus/companies/${this.webinar.id}/agent_settings`,
                method: "POST",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
                data: payload,
            }).then(() => {
                this.$toasted.success(this.$t("agent_settings_save_successfully"));
                this.close()

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("agent_settings_saving_error"));
            });
        }, 
        removeAgentSettings() {
            axios({
                url: `${process.env.VUE_APP_BACKEND_URL}/api/webinar_plus/companies/${this.webinar.id}/agent_settings`,
                method: "DELETE",
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    Authorization: this.$store.get("login/token"),
                },
            }).then(() => {
                this.agentSettingsEditedItem = Object.assign({}, this.agentSettingsDefaultItem);
                this.$toasted.success(this.$t("agent_settings_delete_successfully"));
                this.removeAskDialog=false;
                this.close();

            }).catch(error => {
                console.log(error.response);
                this.$toasted.error(this.$t("agent_settings_deleteing_error"));
            });
        },
   
        close() {
            // this.agentSettingsEditedItem = Object.assign({}, this.agentSettingsDefaultItem);
            //this.selectedAgentSettings={bigbluebutton_secret:'',bigbluebutton_url:''}
            this.$emit('close');
        }
    },
    mounted() {
        this.getAgentSettings();
    },



}
</script>
<style >
.left-input input{
    text-align: left;
    direction: ltr;
}
</style>